import { CONSOLE_BASE_URL } from 'config';

export const openConsole = (path?: string) => {
  window.open(`${CONSOLE_BASE_URL}${path ?? ''}`, '_blank')?.focus();
};
